module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p27",
      "title": "27"
    }
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" QUICK PREP "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")])]), _vm._v(" "), _c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "frozen_blueberry_breakfast_bars"
    }
  }, [_vm._v("Frozen Blueberry Breakfast Bars")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("10 bars")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 10 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 3 Hours 35 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2½")]), _vm._v(" cups oats and honey granola")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup butter, melted")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3")]), _vm._v(" containers (5.3 oz each) Greek blueberry yogurt")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup fresh blueberries")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2")]), _vm._v(" tablespoons oats and honey granola, coarsely crushed")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 350°F. In large bowl, mix 2½ cups granola and the melted butter. Firmly press in bottom of ungreased 8-inch square pan. Bake 10 minutes. Cool 10 minutes on cooling rack. Freeze about 5 minutes or until cold.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" Spoon yogurt over crust; gently spread to cover. Sprinkle with blueberries and crushed granola. Freeze about 3 hours or until firm.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("3")]), _vm._v(" Remove from freezer 10 minutes before cutting. Cut into 5 rows by 2 rows. Wrap tightly. Store in freezer up to 2 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Bar:")]), _vm._v(" Calories 180; Total Fat 7g (Saturated Fat 3g, Trans Fat 0g); Cholesterol 15mg; Sodium 100mg; Total Carbohydrate 24g (Dietary Fiber 1g); Protein 5g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" 1½ Starch, 1 Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" 1½")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_note"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v("Fresh Idea")]), _vm._v(" Ice cream for breakfast! Not really, but with these nutritious, frosty bars in your freezer, breakfast is sure to be fun, as well as fast.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c840232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p027.vue
// module id = 126
// module chunks = 0